const selectFeatureFlagState = state => state?.featureFlag || {};

export const selectIsFeatureFlagPairEnabled = (state, parentFlagId, childFlagId) => {
  const { loading = false, loaded = false, error = null, value = {} } = selectFeatureFlagState(state);
  if (loading || !loaded || error) return false;
  return value?.[parentFlagId]?.status === true && value?.[childFlagId]?.status === true;
};

export const selectAreFeatureFlagsResolved = state => {
  const { loading = false, loaded = false, error = null } = selectFeatureFlagState(state);
  return !loading && (loaded || Boolean(error));
};

export const selectPropertySearchRedesignClientState = state => {
  const { loading = false, loaded = false, error = null, value = {} } = selectFeatureFlagState(state);
  if (loading || !loaded) return undefined;
  if (error) return false;
  return Boolean(value?.property_search_redesign?.status);
};

export const selectIsPropertySearchRedesignEnabled = state => selectPropertySearchRedesignClientState(state) === true;
